import * as React from 'react';
import { stringify } from 'query-string';
import styles from './Map.module.css';
import TokenService from '~services/TokenService';
import { WEBVIEW_MAP_URL } from '~config/map';

export interface MapProps {
  page?: 'detail' | 'indoor-map' | 'beacon-map' | 'map-position' | 'geofence-editor' | 'installer-validate-map' | 'outdoor-draw-tool';
  lat?: number;
  long?: number;
  accuracy?: number;
  siteId?: number | string;
  withBeaconMac?: boolean;
  withBeaconCoordinates?: boolean;
  ignoreMapClick?: boolean;
  height?: number;
  planeId?: number;
  floorSelect?: boolean;
  type?: string;
  planeUuid?: string;
  zoneUuid?: string;
}

const Map = React.forwardRef<HTMLIFrameElement, MapProps>(
  (
    {
      page,
      planeId,
      lat,
      long,
      accuracy,
      siteId,
      ignoreMapClick,
      planeUuid,
      floorSelect,
      height,
      type,
      withBeaconMac,
      zoneUuid,
      withBeaconCoordinates,
    },
    ref
  ) => {
    const MapPath = React.useMemo(() => {
      const query = stringify({
        planeId,
        page,
        lat,
        long,
        accuracy,
        siteId,
        ignoreMapClick,
        planeUuid,
        floorSelect,
        zoneUuid,
        type,
        withBeaconMac,
        withBeaconCoordinates,
        token: TokenService.token?.token,
        endpoint: TokenService.baseUrl.apiUrl,
      });
      return `${WEBVIEW_MAP_URL}?${query}`;
    }, []);

    return (
      <div className={styles.MapEmbed}>
        <iframe key={MapPath} ref={ref} style={{ height }} src={MapPath} />
      </div>
    );
  }
);

export default Map;
